import { trpc } from 'pos-client/utils/trpc.ts';
import { time } from 'pos-shared/utils/secondsHelper.ts';

export const useCurrentUser = () => {
  const response = trpc.getCurrentUser.useQuery(undefined, {
    cacheTime: time.oneHourInSecs,
    staleTime: time.oneHourInSecs,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

  const { data, isLoading, ...rest } = response;

  return {
    currentUser: data,
    isLoadingCurrentUser: isLoading,
    // don't use isFetching please
    ...rest,
  };
};
